import { css as _css } from "@emotion/core";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/core";

function YouTube(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      hoverColor = _ref.hoverColor,
      testId = _ref.testId;
  var theme = useTheme();
  return ___EmotionJSX("svg", {
    css: /*#__PURE__*/_css({
      display: "block",
      fill: primaryColor,
      transition: hoverColor ? theme.transitions.icon : null,
      ":hover": _objectSpread({}, hoverColor && {
        fill: hoverColor
      })
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M16.3395033,6.84081649 C17.8995578,6.84801236 24.3787171,6.90677861 26.1580154,7.38670301 C27.2767627,7.68762579 28.1576672,8.57429174 28.4566696,9.70027772 C29.0000147,11.740998 29.0000147,15.9989741 29.0000147,15.9989741 L29.000002,16.0092505 C28.9995711,16.240469 28.9844905,20.3151173 28.4566696,22.2978183 C28.1576672,23.4236566 27.2767627,24.3103225 26.1580154,24.611393 C24.25458,25.1246618 16.9726125,25.1560864 16.088078,25.1580104 L15.9117503,25.1580104 C15.0272158,25.1560864 7.74524828,25.1246618 5.84181288,24.611393 C4.72321332,24.3103225 3.84216105,23.4236566 3.54315874,22.2978183 C3.06191022,20.4900615 3.00691039,16.9432378 3.00062469,16.1561467 L3.00062469,15.8417967 C3.00691039,15.0546825 3.06191022,11.5077729 3.54315874,9.70027772 C3.84216105,8.57429174 4.72321332,7.68762579 5.84181288,7.38670301 C7.62111119,6.90677861 14.1002705,6.84801236 15.660325,6.84081649 Z M13.3408027,12.1330693 L13.3408027,19.864879 L20.1363098,15.9991219 L13.3408027,12.1330693 Z",
    fillRule: "evenodd"
  }));
}

YouTube.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
  testId: PropTypes.string
};
export default YouTube;